
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bep20-token-development",
      function () {
        return require("private-next-pages/bep20-token-development/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bep20-token-development"])
      });
    }
  